// Glissement animé de la souris entre les cases — fonctions pures, sans DOM.
// La position logique saute de case en case (murs, fromage) ; la position affichée la rejoint en
// glissant, case après case dans l'ordre parcouru (jamais en diagonale à travers un mur), et
// accélère quand plusieurs cases attendent, pour ne jamais traîner derrière le doigt.
import { GLIDE_CELLS_PER_S, GLIDE_CATCH_UP } from '../config/constants.js';

/** @returns {{x:number, y:number, queue:{x:number,y:number}[]}} affichage posé sur `pos` */
export function createGlide(pos) {
  return { x: pos.x, y: pos.y, queue: [] };
}

/** Ajoute une case parcourue (dans l'ordre) à rejoindre. */
export function glideTo(glide, cell) {
  return { ...glide, queue: [...glide.queue, { x: cell.x, y: cell.y }] };
}

/** Avance l'affichage de `dtMs` millisecondes le long des cases en attente. */
export function advanceGlide(glide, dtMs) {
  let { x, y } = glide;
  const queue = [...glide.queue];
  // Vitesse : plus il reste de cases, plus on rattrape vite
  let budget = (GLIDE_CELLS_PER_S * (1 + GLIDE_CATCH_UP * Math.max(0, queue.length - 1)) * dtMs) / 1000;
  while (queue.length > 0 && budget > 0) {
    const target = queue[0];
    const dist = Math.hypot(target.x - x, target.y - y);
    if (dist <= budget) {
      x = target.x;
      y = target.y;
      budget -= dist;
      queue.shift();
    } else {
      x += ((target.x - x) / dist) * budget;
      y += ((target.y - y) / dist) * budget;
      budget = 0;
    }
  }
  return { x, y, queue };
}
